// extracted by mini-css-extract-plugin
export default {"max-answers":"MaxAnswers_max-answers__L770A","max-answers-popover":"MaxAnswers_max-answers-popover__DphzQ"};